import React from "react";

import { getTotalScore } from "../../utils/utils";

function UserRatings({
  partyUsers,
  userScores,
}: {
  partyUsers: any;
  userScores: Scores;
}) {
  if (!userScores || !partyUsers) return null;

  return (
    <div className="mt-6">
      <p className="text-md mb-2">Scores by users in this party:</p>
      {partyUsers?.map((partyUser:any) => {
        if (!userScores[partyUser.userId]) return null;
        const scores = userScores[partyUser.userId];
        const score = getTotalScore(scores);

        return (
          <div
            key={partyUser.userId}
            className="flex items-center text-esc-purple-600 even:text-esc-purple-700 justify-between even:bg-esc-turquoise-600 odd:bg-esc-turquoise-500 p-1.5 px-3"
          >
            <span>{partyUser.name}</span>
            <span className="tracking-widest text-lg">{score}</span>
          </div>
        );
      })}
    </div>
  );
}

export default UserRatings;
